import { createSlice } from "@reduxjs/toolkit";

import Event from "../../ts/models/Event";
import { ServiceAndProducts } from "../../ts/types";

type InitialState = {
  currEvent: Event;
  selectedDate: number;
  servicesProductsOfCurrEvent: ServiceAndProducts[];
};

const emptyEvent = { ...new Event() };

const initialState: InitialState = {
  currEvent: emptyEvent,
  selectedDate: new Date().getTime(),
  servicesProductsOfCurrEvent: [],
};

const events = createSlice({
  name: "events",
  initialState,
  reducers: {
    setCurrEvent: (state, action) => {
      const { event, serviceProductList, selectedDate } = action.payload;
      state.currEvent = event;
      state.servicesProductsOfCurrEvent = serviceProductList;
      state.selectedDate = selectedDate;
    },
  },
});

export const eventsActions = events.actions;

export default events.reducer;
